import { render, staticRenderFns } from "./ComponentServicesTabMain.vue?vue&type=template&id=8ae5e840&scoped=true&"
import script from "./ComponentServicesTabMain.vue?vue&type=script&lang=ts&setup=true&"
export * from "./ComponentServicesTabMain.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./ComponentServicesTabMain.vue?vue&type=style&index=0&id=8ae5e840&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae5e840",
  null
  
)

export default component.exports